<h1>{{ titrePage }}</h1>

<form class="form-horizontal">
	<mat-horizontal-stepper linear #stepper (selectionChange)="stepChange($event)">
		<mat-step [label]="documentPaSteps[0].labelShort" #matStepPv1>
			<document-pa-definition [currentPa]= "currentPa$" (actionRequested)="handleAction($event, stepper)" (categoriePaChange)="categoriePaHasChanged($event)"></document-pa-definition>
		</mat-step>
		<mat-step [label]="documentPaSteps[1].labelShort" #matStepPv2>
			<document-pa-entreprises [currentPa]= "currentPa$" (actionRequested)="handleAction($event, stepper)"></document-pa-entreprises>
		</mat-step>
		<mat-step [label]="documentPaSteps[2].labelShort" #matStepPv3>
			<document-pa-consignes-generales [currentPa]= "currentPa$" (actionRequested)="handleAction($event, stepper)"></document-pa-consignes-generales>
		</mat-step>
		<mat-step [label]="documentPaSteps[3].labelShort" #matStepPv4>
			<consignes-pv [currentPa]="currentPa$" (actionRequested)="handleAction($event, stepper)"></consignes-pv>
		</mat-step>
		<mat-step [label]="documentPaSteps[4].labelShort" #matStepPv5>
			<analyse-risque-generique-pa [currentPa]="currentPa$" (actionRequested)="handleAction($event, stepper)" [type]="'specifique'"></analyse-risque-generique-pa>
		</mat-step>
		<mat-step [label]="documentPaSteps[5].labelShort" #matStepPv6>
			<document-pa-consignes-securite [currentPa]="currentPa$" (actionRequested)="handleAction($event, stepper)"></document-pa-consignes-securite>
		</mat-step>
		<mat-step [label]="documentPaSteps[6].labelShort" #matStepPv7>
			<document-pa-echange [currentPa]="currentPa$" (actionRequested)="handleAction($event, stepper)"></document-pa-echange>
		</mat-step>
		<mat-step [label]="documentPaSteps[7].labelShort" #matStepPv8>
			<analyse-risque-generique-pa [currentPa]="currentPa$" (actionRequested)="handleAction($event, stepper)" [type]="'globale'"></analyse-risque-generique-pa>
		</mat-step>
		<mat-step [label]="documentPaSteps[8].labelShort" #matStepPv9>
			<document-pa-validation-signature [currentPa]="currentPa$" (actionRequested)="handleAction($event, stepper)"></document-pa-validation-signature>
		</mat-step>
	</mat-horizontal-stepper>
</form>
